import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=3f0ed6aa&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=3f0ed6aa&lang=scss&scoped=true&"
import style1 from "./RoleList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ed6aa",
  null
  
)

export default component.exports